(ns pfo.im.core
  (:require [pfo.collection.model :as collection-model]
            [pfo.im.component :as component]
            [pfo.util :as util]))

(defn im [{:keys [query-params]}]
  (if (collection-model/chat-disabled-in-every-family)
    ;; An old link or a bookmark reaches a user whose families lost chat. The
    ;; panel is gone from the page, so opening it would show nothing at all.
    (util/set-location "#/")
    (let [conv-id (when-let [id (:conversation_id query-params)]
                    (js/parseInt id))]
      (component/open-panel! conv-id))))
